import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SearchService } from '@offconon/core-api';

@Injectable({
  providedIn: 'root',
})
export class UniversalLanguageTranslationSaveEditService {
  private searchService = inject(SearchService);

  private destroyRef = inject(DestroyRef);

  postUniversalLanguageTranslation(payload: any) {
    return this.searchService
      .searchUniversalLanguageTranslationCreate(payload)
      .pipe(takeUntilDestroyed(this.destroyRef));
  }

  postBulkUniversalLanguageTranslation(payload: any) {
    return this.searchService
      .searchBulkUniversalLanguageTranslationCreate(payload)
      .pipe(takeUntilDestroyed(this.destroyRef));
  }

  postUniversalLanguageTranslationItem(payload: any) {
    return this.searchService
      .searchUniversalLanguageTranslationItemCreate(payload)
      .pipe(takeUntilDestroyed(this.destroyRef));
  }
}
